export default __webpack_public_path__ + "static/media/Group-21.10020e12.png";